import React, { useState } from 'react';

const ContactTab = () => {
  const [showContact, setShowContact] = useState(false);

  return (
    <div className="space-y-6">
      <div>
        <h3 className="marketing-display-md mb-2 text-m-ink">Contact vendor</h3>
        <p className="marketing-body mb-6 text-m-ink-muted">
          Get in touch with the vendor to discuss your event needs.
        </p>
      </div>

      <div className="space-y-4">
        <button
          type="button"
          onClick={() => setShowContact(!showContact)}
          className="marketing-btn marketing-btn-ink w-full sm:w-auto"
        >
          {showContact ? 'Hide contact' : 'Show contact information'}
        </button>

        {showContact ? (
          <div className="rounded-2xl border border-m-border-light bg-m-surface p-6">
            <p className="mb-2 text-sm text-m-ink-muted">
              Contact information will be available after booking.
            </p>
            <p className="text-xs text-m-ink-faint">
              For security reasons, vendor contact details are only shared with
              confirmed bookings.
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ContactTab;
